/********************************************************
* MODULE TITLE
*
* description text
*
********************************************************/


/**********************************************
 DEPENDANCIES
**********************************************/



/**********************************************
 VARIABLE DECLARATION
**********************************************/

var self = {};



/**********************************************
 HELPER FUNCTIONS
**********************************************/



/**********************************************
 PRIVATE FUNCTIONS
**********************************************/



/**********************************************
 PUBLIC FUNCTIONS
**********************************************/

self.init = function() {
	console.log('this is a module/test file');
}


/**********************************************
 MODULE EXPORT
**********************************************/
module.exports = self;


//////////////////
// WEBPACK FOOTER
// ..-src/javascript/modules/test.js
// module id = 1
// module chunks = 0